<!-- 出版单位详情页 -->
<template>
  <div class='all'>
    <Top :hasShare="false"/>
    <!-- 顶部 -->
    <div class="top">
      <!-- logo -->
      <div class="logo">
        <div class="left">
          <van-image round
                     width="50px"
                     height="50px"
                     fit="cover"
                     :src="$global.imgUrl + orgInfo.coverImg" />
        </div>
        <div class="right">
          <div class="title">
            {{orgInfo.name}}
          </div>
        </div>
      </div>
      <!-- 外文名称 -->
      <div class="public-item">
        <div class="public-title">
          外文名称
        </div>
        <div class="public-text">
          {{orgInfo.englishName}}
        </div>
      </div>
      <!-- 简称 -->
      <div class="public-item">
        <div class="public-title">
          简称
        </div>
        <div class="public-text">
          {{orgInfo.abbreviation}}
        </div>
      </div>
      <!-- 地址 -->
      <div class="public-item">
        <div class="public-title">
          地址
        </div>
        <div class="public-text">
          {{orgInfo.address}}
        </div>
      </div>
      <!-- 官方网址 -->
      <div class="public-item">
        <div class="public-title">
          官方网址
        </div>
        <div class="public-text">
          {{orgInfo.website}}
        </div>
      </div>
      <!-- 机构概述 -->
      <div class="public-item">
        <div class="public-title">
          机构概述
        </div>
        <div class="public-text">
          <p>{{orgInfo.outline}}</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <!-- 主管期刊 -->
      <div class="per-list">
        <div class="title">主管期刊</div>
        <ul>
          <li v-for="(item,index) in orgPeriodical[1]"
              :key="index"
              @click="jumpbaike(item.id)">
            <van-image width="100px"
                       height="140px"
                       :src="$global.imgUrl + item.coverImg" />
            <div class="per-name">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
      <!-- 主办期刊 -->
      <div class="per-list">
        <div class="title">主办期刊</div>
        <ul>
          <li v-for="(item,index) in orgPeriodical[2]"
              :key="index"
              @click="jumpbaike(item.id)">
            <van-image width="100px"
                       height="140px"
                       :src="$global.imgUrl + item.coverImg" />
            <div class="per-name">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
      <!-- 出版期刊 -->
      <div class="per-list">
        <div class="title">出版期刊</div>
        <ul>
          <li v-for="(item,index) in orgPeriodical[3]"
              :key="index"
              @click="jumpbaike(item.id)">
            <van-image width="100px"
                       height="140px"
                       :src="$global.imgUrl + item.coverImg" />
            <div class="per-name">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
      <!-- 机构学者 -->
      <div class="per-list"
           v-if="orgUser.length">
        <div class="title">机构学者</div>
        <ul>
          <li class="scholar"
              v-for="(item,index) in orgUser"
              :key="index"
              @click="jumpbaijia(item.id)">
            <van-image v-if="item.headPhoto"
                       width="65px"
                       round
                       height="65px"
                       fit="cover"
                       :src="$global.imgUrl + item.headPhoto" />
            <img v-else
                 style="width:65px;height:65px"
                 src="@/assets/img/login/4.png"
                 alt="">
            <div class="per-name">
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/views/mobileView/detail/components/Header.vue'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Top
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      orgInfo: [],
      orgUser: [],
      orgPeriodical: [], // 主管/主办/出版期刊集合
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 跳转百科中间页
    jumpbaike(id) {
      this.$router.push({
        path: '/jumpbaike',
        query: {
          id: id
        }
      })
    },
    // 跳转百家中间页
    jumpbaijia(id) {
      this.$router.push({
        path: '/jumpbaijia',
        query: {
          id: id
        }
      })
    },
    getInfo() {
      this.$apis.hundredServe.nfdetail({
        orgId: this.$route.query.orgId
      }).then((result) => {
        this.orgInfo = result.orgInfo
        this.orgUser = result.orgUser
        this.orgPeriodical = result.orgPeriodical
      }).catch((err) => {
        console.log(err)
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
}
</script>
<style lang='scss' scoped>
.all {
  background: #e5e5e5;
  margin-top: 70px;
  .top {
    overflow: hidden;
    padding: 0 16px 26px 16px;
    background-color: #fff;
    .logo {
      margin-top: 14px;
      display: flex;
      align-items: center;
      .left {
        margin-right: 10px;
      }
      .right {
        .title {
          font-size: 15px;
          font-family: PingFang;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
  .bottom {
    padding: 24px 16px 0 16px;
    margin-top: 8px;
    width: 100%;
    background: #fff;
    .per-list {
      .title {
        font-size: 18px;
        font-family: PingFang;
        font-weight: bold;
        color: #303030;
      }
      ul {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        padding: 20px 0;
        overflow-y: auto;
        li {
          width: 100px;
          margin-right: 16px;
          .per-name {
            text-align: center;
          }
        }
        .scholar {
          width: 65px;
          margin-right: 16px;
        }
      }
    }
  }
}
.public-title {
  font-size: 15px;
  font-family: PingFang;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}
.public-item {
  margin-top: 20px;
}
.public-text {
  font-size: 15px;
  font-family: PingFang;
  font-weight: 500;
  color: #333333;
  span {
    margin-right: 10px;
  }
  .per-name {
    padding: 0 8px;
    display: inline-block;
    border: 1px dashed #4585f5;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 16px;
    font-family: PingFang;
    font-weight: 500;
    color: #4459d3;
  }
}
::v-deep .van-image__img {
  vertical-align: middle;
}
</style>